// extracted by mini-css-extract-plugin
export default {"slider":"Slider_slider__XHE5O","thumb":"Slider_thumb__7Zx3S","slider-full-width":"Slider_slider-full-width__L84en","track":"Slider_track__Ai-+D","range":"Slider_range__o7nmr"};